'use client';

import { useAppDispatch } from '@/store/client/config';
import { modalActions } from '@/store/client/slices/modalSlice';

import { SEOLEIMRUN_LINKS } from './constants';
import { useEventPhase } from './useEventPhase';
import { useSeoleimrunNavigate } from './useSeoleimrunNavigate';

// 참가 신청 진입 공통 핸들러 — 히어로 CTA / 드로어 메뉴 양쪽에서 사용.
// 접수 오픈(7/13 10:00) 전이면 안내 모달, 이후에는 신청 페이지로 이동(종료 가드는 navigate 가 처리).
export function useSeoleimrunApply() {
  const navigate = useSeoleimrunNavigate();
  const dispatch = useAppDispatch();
  const { isApplyOpen } = useEventPhase();

  return () => {
    if (!isApplyOpen) {
      dispatch(
        modalActions.openAlertModal({
          icon: 'danger',
          title: ['접수 시작 전 이에요'],
          description: ['7월 13일 10시에 오픈 해요'],
          closeText: ['확인'],
        }),
      );
      return;
    }

    navigate(SEOLEIMRUN_LINKS.apply);
  };
}
